import { createSelector } from 'reselect';
import _get from 'lodash/get';

import { getIsAPMEnabled } from './getIsAPMEnabled';
import { getHasOpenJob } from './getHasOpenJob';
import { getCurrentWorkOrderOp } from './getCurrentWorkOrderOp';
import { getCurrentOperator } from './getCurrentOperator';
import { getCurrentLaborTicket } from './getLaborTickets';
import { getUnattendedOperatorPersonId } from './getUnattendedOperatorPersonId';
import { getIsLaborTicketEnabled } from './getIsLaborTicketEnabled';

const getCanOpenLaborTicket = createSelector(
  [getIsAPMEnabled, getCurrentWorkOrderOp, getHasOpenJob, getCurrentOperator],
  (isAPMEnabled, currentWorkOrderOp, hasOpenJob, currentOperator) => {
    return !!(
      !isAPMEnabled &&
      currentWorkOrderOp &&
      hasOpenJob &&
      _get(currentOperator, 'erpId')
    );
  }
);

const getNeedsForceLogin = createSelector(
  [getIsAPMEnabled, getCurrentOperator, getIsLaborTicketEnabled],
  (isAPMEnabled, currentOperator, isLaborTicketsEnabled) => {
    return !!(!isAPMEnabled && !currentOperator && isLaborTicketsEnabled);
  }
);

const getCanCloseLaborTicket = createSelector(
  [
    getIsAPMEnabled,
    getCurrentOperator,
    getCurrentLaborTicket,
    getCurrentWorkOrderOp,
    getUnattendedOperatorPersonId,
  ],
  (
    isAPMEnabled,
    currentOperator,
    currentLaborTicket,
    currentWorkOrderOp,
    unattendedPersonId
  ) => {
    return !!(
      !isAPMEnabled &&
      (_get(currentOperator, 'erpId') ||
        _get(currentLaborTicket, 'personId') === unattendedPersonId) &&
      currentLaborTicket &&
      currentWorkOrderOp
    );
  }
);

export { getCanOpenLaborTicket, getCanCloseLaborTicket, getNeedsForceLogin };
